module.exports = __webpack_public_path__ + "img/mt.d0ca7e8.svg";